import { getTelegramInitData } from '@/shared/lib/auth/telegramAuth'

export function isTelegramSession(): boolean {
  const tg = (window as any).Telegram?.WebApp
  if (!tg) {
    return false
  }

  const { initData } = getTelegramInitData()
  return Boolean(initData && initData.length > 0)
}

export function isStandaloneDisplayMode(): boolean {
  const navigatorWithStandalone = window.navigator as Navigator & { standalone?: boolean }
  return window.matchMedia('(display-mode: standalone)').matches || navigatorWithStandalone.standalone === true
}
